"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState, useRef } from "react";
export default function PerformanceMetrics() {
  const {
    ref
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollOpacity, setScrollOpacity] = useState(0.15);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const visiblePct = Math.max(0, Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height)));
      setScrollOpacity(0.15 + visiblePct * 0.15);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={sectionRef} data-section-id="223566" id="il-nostro-impatto-globale" className="py-24 lg:py-32 text-foreground relative overflow-hidden" style={{
    backgroundColor: '#FFFFFF'
  }}>
      <div className="absolute inset-0 pointer-events-none transition-opacity duration-500 ease-out" style={{
      opacity: scrollOpacity,
      backgroundImage: `linear-gradient(to right, hsl(182 100% 50% / 0.1) 1px, transparent 1px), linear-gradient(to bottom, hsl(182 100% 50% / 0.1) 1px, transparent 1px)`,
      backgroundSize: '40px 40px',
      animation: 'gridPulse 8s ease-in-out infinite'
    }}></div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes gridPulse {
          0%, 100% { transform: translateY(0); opacity: 0.15; }
          50% { transform: translateY(-20px); opacity: 0.3; }
        }
        @keyframes labelPulse {
          0%, 100% { transform: scale(1); color: inherit; }
          50% { transform: scale(1.05); color: #00F5FF; }
        }
        .animate-label-pulse {
          animation: labelPulse 2.5s ease-in-out infinite;
        }
      `
    }} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref as React.RefObject<HTMLDivElement>} className="text-center">
          <p className="text-primary max-w-3xl mx-auto text-lg md:text-xl font-light leading-relaxed">
            Un approccio multidisciplinare alla mobilità globale. Offriamo soluzioni integrate per navigare la complessità delle normative internazionali con precisione e affidabilità.
          </p>
        </div>
      </div>
    </section>;
}